module.exports = __webpack_public_path__ + "img/portfolio-box-layout.9b414a32.png";